module.exports = __webpack_public_path__ + "img/features_alternating.be026e69.png";